export const UMA_GET_MODEL_CLEAN = {
	success: true,
	errors: [
		{
			'code': 'MODEL_IS_MODIFIED_AT_SOURCE',
			'message': 'no',
			'details': 'The model has been modified at source since its last import'
		},
		{
			'code': 'MODEL_IS_OVERRIDDEN_AT_BLK',
			'message': 'no',
			'details': 'The model has not been reimported from partner platform'
		}

	],
	status: 'OK',
	response: {
		id: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-clean',
		description: 'UMA CLEAN',
		type: 'PORTFOLIO',
		subType: 'THIRD_PARTY_MODEL',
		children: [
			{
				identifier: 'IJR@464287804@US4642878049',
				identifierType: 'SECURITY_ID',
				weight: 50,
				allData: {
					date: 1575900025096,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1575900063898,
					dateLastModified: 1575900063898,
					userEmail: 'apm6@rockymountainsideweatlh.com',
					commonIdentifier: 'IJR@464287804@US4642878049',
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: 'IJR@464287804@US4642878049',
					trackingType: 'userData',
					userPlatformId: '3224231',
					childFlag: true,
					level: 1,
					updateUserId: 'apm6@rockymountainsideweatlh.com',
					weight: 50,
					userId: 'apm6@rockymountainsideweatlh.com',
					updateTimestamp: 1575900070329,
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-clean',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: '464287804',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: 'IJR',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					originPlatform: {
						name: 'iShares Core S&P Small-Cap',
						type: 'SECURITY'
					},
					userTrackingId: '2555447',
					uniqueId: '383159ef-a789-46e8-bdde-2b7432488a56'
				}
			},
			{
				identifier: '270892',
				identifierType: 'MODEL_ID',
				weight: 50,
				allData: {
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: '270892',
					otherIdentifiers: [
						{
							identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'FSP3010',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					positionType: 'VALID',
					weight: 50,
					identifierType: 'MODEL_ID',
					originPlatform: {
						name: 'Model Portfolio 10/90',
						type: 'MANAGED_MODEL'
					},
					type: 'PORTFOLIO_POSITION',
					uniqueId: '06dfe362-a87b-448a-a32e-1f9ae668abde',
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-clean',
					parentType: 'PORTFOLIO'
				}
			}
		],
		allData: {
			origin: 'partner',
			flags: {
				originContainsEditableModel: true,
				originIsfirstTimeImported: true,
				originContainsUnsupportedSMA: false,
				inputWithValues: false,
				isProcessed: false,
				originContainsUnmatchedSecurities: false,
				originContainsUnsupportedManagedAccount: false,
				originContainsAssetClassSubstitutions: false,
				originSleeveContainsUnmatchedSecurities: false,
				originContainsSleeves: false
			},
			description: 'UMA CLEAN',
			type: 'PORTFOLIO',
			parentFlag: true,
			dateCreated: 1561372463377,
			dateLastModified: 1575900063898,
			userEmail: 'apm6@rockymountainsideweatlh.com',
			perms: {
				DELETE: [
					'webUserDataPerm@AdvisorPort'
				],
				SHARE: [
					'webUserDataPerm@AdvisorPort'
				],
				VIEW: [
					'webUserDataPerm@AdvisorPort'
				]
			},
			owner: {
				userPlatformId: '3224231',
				userEmail: 'apm6@rockymountainsideweatlh.com',
				userId: 'apm6@rockymountainsideweatlh.com'
			},
			ssoIdp: 'envestnet',
			toolOrigin: 'partner',
			userPlatformId: '3224231',
			level: 0,
			updateUserId: 'apm6@rockymountainsideweatlh.com',
			childCount: 9,
			userId: 'apm6@rockymountainsideweatlh.com',
			updateTimestamp: 1575900070330,
			otherIdentifiers: [
				{
					identifier: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-clean',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				}
			],
			subType: 'THIRD_PARTY_MODEL',
			originPlatform: {
				firm: 'demof',
				dateImported: '1561372463360',
				programHandle: '0100000AEEN01613H3MJAZEPFRG6GLHUIJ76FX664I5JKQH6OH6I5XGYWSI3Z6KJBLQLA====',
				externalModelDateLastModified: '1575899995393',
				riskHandle: '0100000AOOP03321HTZQ7VWJVZ2P2NE37Q6EBTMYEEZXYQSSSQHLLZVDZUMUSKTJBMLZA====',
				platform: 'ENVESTNET'
			},
			userTrackingId: '2555447',
			uniqueId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-clean',
			applications: [
				'partner',
				'bfa'
			]
		}
	},
	responseTimes: {
		root: {
			nodes: []
		}
	}
};
